var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7429 7.04874C15.4196 6.7079 14.8807 6.69289 14.5393 7.01696L9.10431 12.1713L6.51196 9.50972C6.18363 9.17286 5.6453 9.16548 5.30815 9.49385C4.97129 9.82189 4.96419 10.3608 5.29224 10.6977L8.47062 13.9609C8.63719 14.132 8.85855 14.2183 9.08048 14.2183C9.29106 14.2183 9.50163 14.1405 9.66651 13.9847L15.7111 8.25231C16.0522 7.92878 16.0666 7.38987 15.7429 7.04874Z",
    fill: "#0FA76E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71023 0 0 4.71023 0 10.5C0 16.2898 4.71023 21 10.5 21C16.2898 21 21 16.2898 21 10.5C21 4.71023 16.2898 0 10.5 0ZM10.5 19.2973C5.64929 19.2973 1.70268 15.351 1.70268 10.5C1.70268 5.64929 5.64925 1.70268 10.5 1.70268C15.351 1.70268 19.2973 5.64925 19.2973 10.5C19.2973 15.351 15.351 19.2973 10.5 19.2973Z",
    fill: "#0FA76E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.bdbec7386991acdfcbca1c6100a43865.svg";
export { ForwardRef as ReactComponent };